import { render } from "./WorstSites.vue?vue&type=template&id=8e0785de&scoped=true"
import script from "./WorstSites.vue?vue&type=script&lang=js"
export * from "./WorstSites.vue?vue&type=script&lang=js"

import "./WorstSites.vue?vue&type=style&index=0&id=8e0785de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0785de"]])

export default __exports__